export const PASSWORD_MIN_LENGTH = 10;

export const PASSWORD_TOO_SHORT_MESSAGE = `Le mot de passe doit contenir au moins ${PASSWORD_MIN_LENGTH} caractères.`;

export function isValidNewPassword(password: string): boolean {
  return password.length >= PASSWORD_MIN_LENGTH;
}
